const composeValidators = (...validators) => {
  // Filter out any non-function validators
  const validValidators = validators.filter(validator => typeof validator === 'function');
  
  // If no valid validators, return undefined (no validation)
  if (validValidators.length === 0) {
    return undefined;
  }
  
  // Return a function that runs all validators
  return (value) => {
    return validValidators.reduce((error, validator) => {
      if (error) return error; // Return first error found
      if (typeof validator !== 'function') return error; // Skip non-functions
      return validator(value);
    }, undefined);
  };
}

export default composeValidators;